import React from 'react';
import { RadioListTwoColumn } from '../ui/RadioListTwoColumn';
import { PrimaryButtonGreen } from '../ui/Buttons';
import { useSticker } from '../../context/StickerContext';
import { useToast } from '../ui/Toast';
import { Plus, Minus } from 'lucide-react';
export function QuantityPanel() {
  const {
    quantity,
    setQuantity,
    totalPrice,
    pricePerSticker
  } = useSticker();
  const {
    addToast
  } = useToast();
  const quantityOptions = [50, 100, 250, 500, 1000, 2000, 'Custom quantity'];
  const handleQuantityChange = (val: any) => {
    if (val === 'Custom quantity') {
      setQuantity(350); // Default custom for editor
    } else {
      setQuantity(Number(val));
    }
  };
  const handleContinue = () => {
    addToast('Quantity updated');
  };
  return <div className="h-full flex flex-col" data-id="element-115">
      <div className="p-4 border-b border-gray-100" data-id="element-116">
        <h2 className="font-semibold text-gray-900" data-id="element-117">Quantity</h2>
      </div>

      <div className="p-4 space-y-6 overflow-y-auto flex-1" data-id="element-118">
        <RadioListTwoColumn name="editor_quantity" options={quantityOptions} value={quantityOptions.includes(quantity) ? quantity : 'Custom quantity'} onChange={handleQuantityChange} data-id="element-119" />

        {!quantityOptions.includes(quantity) && <div data-id="element-120">
            <div className="relative" data-id="element-121">
              <input type="number" value={quantity} onChange={e => setQuantity(Number(e.target.value))} className="w-full rounded-lg border border-gray-200 px-4 py-2.5 text-sm focus:ring-2 focus:ring-violet-500 outline-none" data-id="element-122" />
              <div className="absolute right-2 top-1/2 -translate-y-1/2 flex flex-col" data-id="element-123">
                <button onClick={() => setQuantity(quantity + 1)} className="text-gray-400 hover:text-violet-600" data-id="element-124">
                  <Plus size={12} data-id="element-125" />
                </button>
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="text-gray-400 hover:text-violet-600" data-id="element-126">
                  <Minus size={12} data-id="element-127" />
                </button>
              </div>
            </div>
            <p className="text-xs text-gray-400 mt-1" data-id="element-128">
              The range of values is 1 to 2000
            </p>
          </div>}

        <div className="pt-4 border-t border-gray-100" data-id="element-129">
          <p className="text-sm text-gray-500 mb-1" data-id="element-130">
            ${pricePerSticker} per sticker
          </p>
          <p className="text-lg font-bold text-gray-900" data-id="element-131">
            Total: $
            {totalPrice.toLocaleString('en-US', {
            minimumFractionDigits: 2
          })}
          </p>
        </div>
      </div>

      <div className="p-4 border-t border-gray-100" data-id="element-132">
        <PrimaryButtonGreen className="w-full" onClick={handleContinue} data-id="element-133">
          Continue
        </PrimaryButtonGreen>
      </div>
    </div>;
}